import React, { useState, createContext } from 'react';
const axios = require('axios')
const { API_URL } = require('../MetaData/Metadata')


// Exporting Context
export const AuthContext = createContext();

const AuthContextProvider = (props) => {
    // Check for token existing token in localstorage
    const checkTokenExists = () => {
        return localStorage.hasOwnProperty('token')
    }

    const [isAuthenticated, setIsAuthenticated] = useState(checkTokenExists());

    // Login
    const login = async (register_no, password) => {
        try {
            const apiRoute = `${API_URL}/student/login`;
            const loginRequest = await axios.post(apiRoute, { register_no: register_no, password: password });
            const response = await loginRequest.data;
            localStorage.setItem('token', response.token);
            setIsAuthenticated(true);
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <AuthContext.Provider value={{ login, isAuthenticated, setIsAuthenticated }}>
            {props.children}
        </AuthContext.Provider>
    );
}
export default AuthContextProvider;
